import { api } from "@/redux/api";

import {
	CreateLanguageRule,
	DefaultOutputLanguage,
	DefaultOutputLanguageSchema,
	LanguageRuleInfo,
	LanguageRuleInfoSchema,
	LanguageRuleListResponse,
	LanguageRuleListResponseSchema,
	ReorderLanguageRules,
	UpdateLanguageRule,
} from "../../pages/Messages/schema/languageRule";

export const languageRuleApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getLanguageRules: builder.query<LanguageRuleListResponse, void>({
			query: () => ({
				url: "language-rules",
				responseSchema: LanguageRuleListResponseSchema,
			}),
			providesTags: ["LanguageRule"],
		}),

		createLanguageRule: builder.mutation<LanguageRuleInfo, CreateLanguageRule>({
			query: (body) => ({
				url: "language-rules",
				method: "POST",
				body,
				responseSchema: LanguageRuleInfoSchema,
			}),
			invalidatesTags: ["LanguageRule"],
		}),

		updateLanguageRule: builder.mutation<
			LanguageRuleInfo,
			{ id: number; body: UpdateLanguageRule }
		>({
			query: ({ id, body }) => ({
				url: `language-rules/${id}`,
				method: "PATCH",
				body,
				responseSchema: LanguageRuleInfoSchema,
			}),
			invalidatesTags: ["LanguageRule"],
		}),

		deleteLanguageRule: builder.mutation<void, number>({
			query: (id) => ({
				url: `language-rules/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["LanguageRule"],
		}),

		reorderLanguageRules: builder.mutation<LanguageRuleListResponse, ReorderLanguageRules>({
			query: (body) => ({
				url: "language-rules/reorder",
				method: "PATCH",
				body,
				responseSchema: LanguageRuleListResponseSchema,
			}),
			invalidatesTags: ["LanguageRule"],
		}),

		getDefaultLanguage: builder.query<DefaultOutputLanguage, void>({
			query: () => ({
				url: "language-rules/default-language",
				responseSchema: DefaultOutputLanguageSchema,
			}),
			providesTags: ["LanguageRule"],
		}),

		setDefaultLanguage: builder.mutation<DefaultOutputLanguage, DefaultOutputLanguage>({
			query: (body) => ({
				url: "language-rules/default-language",
				method: "PUT",
				body,
				responseSchema: DefaultOutputLanguageSchema,
			}),
			invalidatesTags: ["LanguageRule"],
		}),
	}),
});

export const {
	useGetLanguageRulesQuery,
	useCreateLanguageRuleMutation,
	useUpdateLanguageRuleMutation,
	useDeleteLanguageRuleMutation,
	useReorderLanguageRulesMutation,
	useGetDefaultLanguageQuery,
	useSetDefaultLanguageMutation,
} = languageRuleApi;
